/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_BackInputs */

const en_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All articles`)
};

const lv_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visi raksti`)
};

/**
* | output |
* | --- |
* | "All articles" |
*
* @param {Blog_BackInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const blog_back = /** @type {((inputs?: Blog_BackInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_BackInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_blog_back(inputs)
	return en_blog_back(inputs)
});